import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from 'react';

const ContentContext = createContext({
  content: null,
  loading: true,
  error: '',
  refresh: () => {}
});

export const ContentProvider = ({ children }) => {
  const API_BASE = process.env.REACT_APP_BACKEND_URL;
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // K17: a teljes tartalom-dokumentum ~30 kB, ebből ~21 kB a három jogi szöveg
  // (adatkezelés, ÁSZF, cookie) – azok viszont CSAK három oldalon kellenek.
  // Alapból tehát nélkülük kérjük; a jogi oldalak (és az admin) `withLegal`-lal
  // kérik újra. Így minden MÁS oldalbetöltés ~9 kB-ot tölt 30 helyett.
  const fetchContent = useCallback(async (withLegal = false) => {
    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${API_BASE}/api/content${withLegal ? '?include=legal' : ''}`);
      if (!response.ok) {
        throw new Error('Failed to load content');
      }
      const data = await response.json();
      // Összefésülés: a jogi szövegek betöltése ne dobja el a már meglévő
      // mezőket (és fordítva se) – az alap-lekérés után érkező bővített
      // válasz csak KIEGÉSZÍTI a képet.
      setContent((prev) => ({ ...(prev || {}), ...data }));
    } catch (err) {
      setError('A tartalom betöltése sikertelen.');
    } finally {
      setLoading(false);
    }
  }, [API_BASE]);

  // A jogi szövegek igénylése – a PrivacyPage/TermsPage/CookiePage hívja.
  // Idempotens: ha már megvan, nem kér újra.
  const loadedLegal = useRef(false);
  const requestLegal = useCallback(() => {
    if (loadedLegal.current) return;
    loadedLegal.current = true;
    fetchContent(true);
  }, [fetchContent]);

  useEffect(() => {
    fetchContent();
  }, [fetchContent]);

  return (
    <ContentContext.Provider value={{ content, loading, error, refresh: fetchContent, requestLegal }}>
      {children}
    </ContentContext.Provider>
  );
};

export const useContent = () => useContext(ContentContext);
